import { buildApiUrl } from "../../../config.js";
import React, { useEffect, useState } from "react";
import axios from "axios";

const ReturnModal = ({ returnData, setReturnData, handleModalClose, handleReturnSubmit }) => {
  const [warehouseNames, setWarehouseNames] = useState([]);

  useEffect(() => {
    // Fetch warehouse names when the component mounts
    const fetchWarehouseNames = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(buildApiUrl("/api/warehouse/inventory/warehousename"), {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the header
          },
        });
        if (response.data && response.data.data) {
          setWarehouseNames(response.data.data); // Store warehouse names in the state
        }
      } catch (error) {
        console.error("Error fetching warehouse names:", error);
      }
    };

    fetchWarehouseNames();
  }, []); // Re-fetch if the token changes

  const handleDefectiveQuantityChange = (e, index) => {
    const updatedDefectiveQuantity = e.target.value;
    const updatedItems = [...returnData.items];
    const defectiveQty = Number(updatedDefectiveQuantity);
    const okayQty = Number(updatedItems[index].okayQuantities);
    const totalQty = defectiveQty + okayQty;

    if (totalQty <= updatedItems[index].itemqty) {
      updatedItems[index].defectiveQuantities = defectiveQty;
      setReturnData({ items: updatedItems });
    } else {
      alert("The combined defective and okay quantities cannot exceed the total item quantity.");
    }
  };

  const handleOkayQuantityChange = (e, index) => {
    const updatedOkayQuantity = e.target.value;
    const updatedItems = [...returnData.items];
    const okayQty = Number(updatedOkayQuantity);
    const defectiveQty = Number(updatedItems[index].defectiveQuantities);
    const totalQty = defectiveQty + okayQty;

    if (totalQty <= updatedItems[index].itemqty) {
      updatedItems[index].okayQuantities = okayQty;
      setReturnData({ items: updatedItems });
    } else {
      alert("The combined defective and okay quantities cannot exceed the total item quantity.");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-4 rounded-lg w-full max-w-6xl">
        <h3 className="text-lg mb-2">Return Details</h3>
  
        <div className="mb-2">
          <label className="block mb-1 text-sm">Warehouse Name</label>
          <select
            value={returnData.warehouseName}
            onChange={(e) => setReturnData({ ...returnData, warehouseName: e.target.value })}
            className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
          >
            <option value="">Select Warehouse</option>
            {warehouseNames.map((warehouseName, index) => (
              <option key={index} value={warehouseName}>
                {warehouseName}
              </option>
            ))}
          </select>
        </div>
  
        {returnData.items.map((item, index) => (
          <div key={index} className="mb-3">
            <h4 className="text-md font-semibold mb-2">Item {index + 1}</h4>
            <div className="grid grid-cols-6 gap-1">
              <div className="flex-1">
                <label className="block text-sm mb-1">Category</label>
                <input
                  type="text"
                  value={item.categoryName}
                  readOnly
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Item Code</label>
                <input
                  type="text"
                  value={item.itemCode}
                  readOnly
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Item Name</label>
                <input
                  type="text"
                  value={item.itemName}
                  readOnly
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Item Qty</label>
                <input
                  type="text"
                  value={item.itemqty}
                  readOnly
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Defective Quantity</label>
                <input
                  type="number"
                  value={item.defectiveQuantities}
                  onChange={(e) => handleDefectiveQuantityChange(e, index)}
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
              <div className="flex-1">
                <label className="block text-sm mb-1">Okay Quantity</label>
                <input
                  type="number"
                  value={item.okayQuantities}
                  onChange={(e) => handleOkayQuantityChange(e, index)}
                  className="w-full p-1.5 border border-gray-300 rounded-md text-sm"
                />
              </div>
            </div>
  
            {item.defectiveQuantities + item.okayQuantities > item.itemqty && (
              <p className="text-red-500 text-xs mt-1">
                The combined defective and okay quantities cannot exceed the total item quantity.
              </p>
            )}
          </div>
        ))}
  
        <div className="flex justify-between mt-4">
          <button onClick={handleModalClose} className="px-3 py-1.5 bg-gray-500 text-white rounded-md text-sm">Cancel</button>
          <button onClick={handleReturnSubmit} className="px-3 py-1.5 bg-red-500 text-white rounded-md text-sm">Return</button>
        </div>
      </div>
    </div>
  );
  
  
};

export default ReturnModal;
